export const createFromTemplate = (template: string): DocumentFragment => {
    const range = document.createRange();
    return range.createContextualFragment(template);
};
